import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { CrmFeatures } from 'src/app/shared/enumerations/crm.enumeration';
import { PropertyDataType, SortHelper } from 'src/app/shared/helpers/sort.helper';
import { HsformService } from 'src/app/shared/services/hsform.service';
import { Department, CrmUser, UserInfo } from '../../../shared/models/user.model';
import {
  EnvironmentData,
  EnvironmentService
} from '../../services/environment.service';
import { WordMarkService } from 'src/app/shared/services/wordmarkservice';

@Component({
  selector: 'app-app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.css'],
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  @Input()
  allowed = false;
  @Input()
  securityChecked = false;

  logoUrl: string;
  features: string[];
  envInfo: EnvironmentData;
  crmAppUrl: string;
  items: MenuItem[];
  user: CrmUser;
  department: MenuItem[];
  selDepartment: Department;
  selectedDeptSub: Subscription;
  isHideHeader: boolean;
  portalItems: MenuItem[] = [];
  displayName: string;

  constructor(private envService: EnvironmentService, public router: Router, private hsformService: HsformService, private wordMarkService: WordMarkService) {
    this.wordMarkService.getData().subscribe((wordMarks) => {
      const feature = wordMarks.find((item) => item.name === 'UC Davis Health');
      if (feature) {
        this.logoUrl = feature.cdnLogoUrl;
      }
    });
    this.envService.getUserDepartments().subscribe((departments) => {
      SortHelper.sortArrayByPropertyValue(
        departments,
        'departmentName',
        PropertyDataType.STRING
      );
      departments.forEach(department => {
        this.portalItems.push({
          id: department.departmentCode,
          label: department.departmentName,
          command: (event) => {
            this.selDepartment.departmentCode = event.item.id;
            this.selDepartment.departmentName = event.item.label;
            this.hsformService.triggerSelectedDept(department);
            this.evaluateItems();
          }
        })
      });
      this.selDepartment = departments[0];

    });


    // this.selectedDept = this.portalItems[0].label;
    this.selectedDeptSub = this.hsformService.getSelectedDept().subscribe(department => {
      if (department) {
        this.selDepartment = department;
        this.hsformService.setDepartmentCode(department.departmentCode);
        this.evaluateItems();
      }
    });

    this.envService.getEnvironment().subscribe((envMap) => {
      this.envInfo = envMap;
      this.crmAppUrl = envMap.crmAppUrl;
      this.evaluateItems();
    });
  }

  ngOnInit(): void {
    const winUrl = window.location.href;
    this.isHideHeader = (winUrl.indexOf('view-form') > 0) ? true : false;
  }

  evaluateItems() {
    this.envService.getCrmUser().subscribe((userModel) => {
      if (this.envInfo) {
        this.envService.getUserInfo().subscribe(userInfo => {
          this.displayName = this.displayNameForUser(userInfo);
        });
      }

      this.user = userModel;
      this.items = [
        {
          label: 'Manage Forms',
          command: () => {
            if (
              this.user.crmAuthorities.find(
                (crmAuthority) => crmAuthority.department === this.selDepartment.departmentCode && crmAuthority.feature === CrmFeatures.HSFORM_MANAGE_FORM
              )
            ) {
              this.router.navigate(['/manage-forms']);
            }
          },
          disabled:
            !this.user.crmAuthorities.find(
              (crmAuthority) => crmAuthority.department === this.selDepartment.departmentCode && crmAuthority.feature === CrmFeatures.HSFORM_MANAGE_FORM
            ),
        },
        {
          label: 'Manage Questions',
          command: () => {
            if (
              this.user.crmAuthorities.find(
                (crmAuthority) => crmAuthority.department === this.selDepartment.departmentCode && crmAuthority.feature === CrmFeatures.HSFORM_MANAGE_QUESTION
              )
            ) {
              this.router.navigate(['/manage-questions']);
            }
          },
          disabled:
            !this.user.crmAuthorities.find(
              (crmAuthority) => crmAuthority.department === this.selDepartment.departmentCode && crmAuthority.feature === CrmFeatures.HSFORM_MANAGE_QUESTION
            ),
        },
        { label: 'CRM', url: this.crmAppUrl, target: '_blank' },
      ];

    });
  }

  ngOnDestroy() {
    this.selectedDeptSub.unsubscribe();
  }

  public displayNameForUser(userInfo: UserInfo): string {
    return userInfo.firstName + " "
      + (!userInfo.middleName || userInfo.middleName.length == 0 ? "" : (userInfo.middleName + " "))
      + userInfo.lastName;
  }
}
